import React from 'react';
import { withStyles } from '@mui/styles';
import AddIcon from 'img/add.svg';

const styles = theme => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        position: 'relative',
        backgroundColor: '#ffffff',
        cursor: 'pointer',
        fontSize: 16,
        fontWeight: 700,
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.2px',
        textAlign: 'center',
        color: theme.palette.grey[900],
        borderRadius: 8,
        padding: 20,
        border: `2px solid ${theme.palette.grey[200]}`,
        '&:hover': {
            backgroundColor: theme.palette.grey[50]
        },
        '& img': {
            marginRight: 15
        }
    }
});

const CreateBox = ({ onClick, classes }) => (
    <div role="presentation" onClick={onClick} className={`js-add-question ${classes.wrapper}`}>
        <img src={AddIcon} alt="+" />
        Add question
    </div>
);

export default withStyles(styles)(CreateBox);
